
export default class WDFormat {

  static boolean(val)
  {
    return Number(val).formatBoolean();
  };

  static date(val)
  {
    return val ? WDFormat.customDate(val,'m/d/Y') : '';
  };

  static customDate(val,str)
  {
    if (val === null) return '';
    if (!str) str = 'm/d/Y';

    const dateVal = (typeof(val) == 'object') ? val : new Date(val);

    //utc fix, if not passed any time, add one day
    if ( typeof(val) == 'string' && val.indexOf(':') == -1 ) dateVal.addDays(1);

    return dateVal.format(str);
  };

  static dateTime(val)
  {
    if (!val) return '';
    
    const dateVal = (typeof (val) == 'object') ? val : new Date(val);
    return dateVal.format('m/d/Y h:i a');
  };

  static time(val)
  {
    if (!val) return '';

    const dateVal = (typeof(val) == 'object') ? val : new Date(val);
    return dateVal.format('h:i a');
  };

  static dateTime24(val)
  {
    if (!val) return '';
    
    const dateVal = (typeof(val) == 'object') ? val : new Date(val);
    return dateVal.format('m/d/Y H:i:s');
  };

  static size(val)
  {
    return Number(val).formatSize();
  };

  static currency(val)
  {
    if (typeof(val) == 'string') 
    {
      val = val.replace(/[^0-9.\-()]/g,'');
    }
    return Number(val).formatCurrency(0);
  };    

  static currencyDecimals(val)
  {
    if (typeof(val) == 'string') 
    {
      val = val.replace(/[^0-9.\-()]/g,'');
    }
    return Number(val).formatCurrency(2);
  };    

  static percent(val,precision)
  {
    if (!precision) precision = '0';
    return Number(val).formatPercent(precision);
  };

  static phone(val)
  {
    if (val === null || String(val).trim().length == '0') return '';

    let str = String(val).replace(/[^0-9]+/g,'');
  
	  if (str.length==11)
	  {
	    str = str.substr(1);
	    str = "(" + str.substr(0,3) + ") " + str.substr(3,3) + "-" + str.substr(6);
	  }
	  else if (str.length==12)
	  {
	    str = str.substr(1);
	    str = "(" + str.substr(1,3) + ") " + str.substr(4,3) + "-" + str.substr(7);
	  }
	  else if (str.length==10)
	  {
	    str = "(" + str.substr(0,3) + ") " + str.substr(3,3) + "-" + str.substr(6);
	  }
	  else if (str.length==7)
	  {
	    str = str.substr(0,3) + "-" + str.substr(3);
	  }
	
	  return str;
  };

  static titleCase(str)
  {
    return str !== null ? String(str).titleCase() : null;
  }
};

